import { trim } from 'lodash-es'
import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CompanyContext } from '../../contexts'
import {
  clearErrorsFromServer as clearErrorsFromServerAction,
  createCompany as createCompanyAction,
  loadCompanies as loadCompaniesAction,
  setCreatedSuccessModalVisibility as setCreatedSuccessModalVisibilityAction,
  setNewCompanyModalVisibility as setNewCompanyModalVisibilityAction,
} from '../../slices/company_slice'
import CompanyFormModal from '../modals/CompanyFormModal'
import CompanyFormContent from './CompanyFormContent'
import SuccessModalContent from './SuccessModalContent'

export function NewCompany() {
  const { company_types } = useContext(CompanyContext)
  const { newCompanyModalVisibility, createdSuccessModalVisibility } = useSelector(
    (state) => state.company
  )
  const dispatch = useDispatch()

  useEffect(() => {
    if (!createdSuccessModalVisibility) return

    setTimeout(() => {
      dispatch(loadCompaniesAction({ query: '*' }))
    }, 3000)
    onCloseNewCompanyModal()
  }, [createdSuccessModalVisibility])

  const handleSubmit = async (data) => {
    const formData = new FormData()
    const forms = {
      name: data.name,
      company_type: data.company_type,
    }

    Object.keys(forms).forEach((key) => {
      formData.append(`company[${key}]`, forms[key])
    })
    data.company_aliases_attributes.forEach((item) => {
      if (!!trim(item.name)) {
        formData.append('company[company_aliases_attributes][][name]', item.name)
      }
    })
    if (data.company_logo.length > 0) formData.append('company[logo]', data.company_logo[0])

    dispatch(createCompanyAction({ data: formData }))
  }
  const onCloseNewCompanyModal = () => {
    dispatch(clearErrorsFromServerAction('new'))
    dispatch(setNewCompanyModalVisibilityAction(false))
  }

  const onCloseCreatedSuccessModal = () => {
    dispatch(setCreatedSuccessModalVisibilityAction(false))
  }

  return (
    <>
      <CompanyFormModal open={newCompanyModalVisibility}>
        <CompanyFormContent
          company_types={company_types}
          onBack={onCloseNewCompanyModal}
          onNext={handleSubmit}
        />
      </CompanyFormModal>
      <CompanyFormModal open={createdSuccessModalVisibility}>
        <SuccessModalContent title={`company added!`} onNext={onCloseCreatedSuccessModal} />
      </CompanyFormModal>
    </>
  )
}
